import { AuthorResponse } from "../../types/api/common"
import { Button, Avatar, Stack, Text } from '@primer/react'

interface UserTableRowProps {
    user: AuthorResponse | undefined
    onClick?: () => void;
}

export const UserTableRow: React.FC<UserTableRowProps> = ({ user, onClick }) => {
    const username = (user?.username === 'Unknown User' || user?.username == null) ? 'Гость' : user?.username

    const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = "/icons/avatar.png";
    };

    return (
        <Stack direction="horizontal" align="center">
            <Avatar
                src={user?.avatar?.preview ?? "/icons/avatar.png"}
                alt="28"
                size={40}
                className='w-[28}px] aspect-square object-cover object-center rounded-full'
                onError={handleAvatarError}
            />
            <Stack gap='none'>
                {username === "Гость" ? (
                    <Text
                        as="span"
                        weight='semibold'
                        className='text-[14px] text-aloix-black'
                    >
                        {username}
                    </Text>
                ) : (
                    <Button
                        onClick={onClick}
                        className='!h-[2px] -ml-2'
                        size="small"
                        variant="invisible"
                    >
                        <Text
                            as="span"
                            weight='semibold'
                            className='text-[14px] text-aloix-black'
                        >
                            {username}
                        </Text>
                    </Button>
                )}

            </Stack>
        </Stack>
    )
}
